import React from "react";

export default function () {
  return (
    <div>
      <h2 className="text-center"> Page Not Found</h2>
    </div>
  );
}
